if (!customElements.get('seo-toc-nav')) {
  customElements.define(
    'seo-toc-nav',
    class SeoTocNav extends HTMLElement {
      connectedCallback() {
        const content = this.querySelector('.seo-content');
        const nav = this.querySelector('.seo-toc');
        const tocList = this.querySelector('.seo-toc ul');
        if (!content || !nav || !tocList) return;

        const headings = content.querySelectorAll('h2, h3');
        if (!headings.length) {
          nav.hidden = true;
          return;
        }

        headings.forEach(heading => {
          if (!heading.id) heading.id = this.createAnchor(heading.textContent);

          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = '#' + heading.id;
          a.textContent = heading.textContent;
          li.appendChild(a);
          tocList.appendChild(li);

          a.addEventListener('click', event => {
            event.preventDefault();
            heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.replaceState(null, null, '#' + heading.id);
          });
        });
      }

      createAnchor(text) {
        return text
          .toLowerCase()
          .replace(/ä/g, 'ae')
          .replace(/ü/g, 'ue')
          .replace(/ö/g, 'oe')
          .replace(/ß/g, 'ss')
          .replace(/[^a-z0-9\s]/g, '')
          .replace(/\s+/g, '-');
      }
    }
  );
}